/**
 * Preview map keys: Pluggy uses real account id; JSON/Excel use prefixed keys with name slug.
 */

export const PREVIEW_JSON_KEY_PREFIX = '__import_json__';
export const PREVIEW_EXCEL_KEY_PREFIX = '__import_excel__';

/** Legacy single-slot keys (still recognized by resolvePreviewSource). */
export const PREVIEW_IMPORT_JSON_ACCOUNT_ID = `${PREVIEW_JSON_KEY_PREFIX}`;
export const PREVIEW_IMPORT_EXCEL_ACCOUNT_ID = `${PREVIEW_EXCEL_KEY_PREFIX}`;

export function normalizePreviewAccountName(name) {
  return (name || '').trim().toLowerCase();
}

/** URL-safe slug for localStorage / object keys (case-insensitive source). */
export function slugForPreviewImportName(name) {
  const t = (name || '').trim().toLowerCase();
  if (!t) return 'default';
  const s = t
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
  return s || 'default';
}

export function makePreviewImportJsonKey(displayName) {
  return `${PREVIEW_JSON_KEY_PREFIX}::${slugForPreviewImportName(displayName)}`;
}

export function makePreviewImportExcelKey(displayName) {
  return `${PREVIEW_EXCEL_KEY_PREFIX}::${slugForPreviewImportName(displayName)}`;
}

export function isJsonImportKey(key) {
  const k = String(key || '');
  return k === PREVIEW_JSON_KEY_PREFIX || k.startsWith(`${PREVIEW_JSON_KEY_PREFIX}::`);
}

export function isExcelImportKey(key) {
  const k = String(key || '');
  return k === PREVIEW_EXCEL_KEY_PREFIX || k.startsWith(`${PREVIEW_EXCEL_KEY_PREFIX}::`);
}

/**
 * Drop entries whose account_name matches (trim + case-insensitive).
 */
export function removePreviewEntriesMatchingAccountName(prev, accountName) {
  const target = normalizePreviewAccountName(accountName);
  if (!target) return { ...prev };
  const next = { ...prev };
  Object.keys(next).forEach((key) => {
    const nm = normalizePreviewAccountName(next[key]?.account?.account_name);
    if (nm === target) delete next[key];
  });
  return next;
}
